import { ActionCard, Flow } from '@playbooks/core/src/interfaces/ActionCard'

import getAllAssessments from './getAllAssessments'
import isConditionSatisfied from './isConditionSatisfied'
import { FlowData } from './types'

function getFlowStatus(state: ActionCard): FlowData {
  let res: Flow = Flow.PLAY as Flow
  let responseId: number | null = null

  find()

  function find() {
    const relevantAssessments = getAllAssessments(state.sections)

    for (const assess of relevantAssessments) {
      const isResponseAccessible = isConditionSatisfied(
        assess.tags || null,
        state.conditionalItems || [],
        assess.conditionRule || null,
      )

      for (const resp of assess.responses) {
        if (
          (resp.flow === Flow.PAUSE || resp.flow === Flow.STOP || resp.flow === Flow.COMPLETE) &&
          resp.checked &&
          isResponseAccessible
        ) {
          if (res !== Flow.PLAY) return

          res = resp.flow
          responseId = resp.id
        }
      }
    }
  }

  return {
    flow: res,
    responseId,
  }
}

export default getFlowStatus
